import {connect} from 'react-redux';
import Publish from './Status.jsx';
import {handlePublish, handleBeginExport, handleDownloadExport} from './actions';
import {displayConfirmStatusChangeModal} from './actionTypes';

const mapStateToProps = state => state.tournament.status;

const mapDispatchToProps = dispatch => ({
  onPublishClick: () => dispatch(handlePublish()),
  onSetStatusClick: status => dispatch(displayConfirmStatusChangeModal(status)),
  onExportClick: () => dispatch(handleBeginExport()),
  onDownloadExportClick: () => dispatch(handleDownloadExport())
});

export default connect(mapStateToProps, mapDispatchToProps)(Publish);



// WEBPACK FOOTER //
// ./src/features/tournament/status/StatusContainer.jsx